// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { useEffect } from 'react';

export function useHubspot(id: string, context: Record<string, string>) {
  useEffect(() => {
    const formShell = document.createElement('script');
    formShell.src = '//js.hsforms.net/forms/shell.js';
    document.body.appendChild(formShell);
    /* eslint-disable */
    formShell.addEventListener('load', () => {
      // @ts-expect-error hubspot provides its own non-type safe library so this tries to load it
      if (window.hbspt) {
        // @ts-expect-error hubspot provides the API contract for this
        window.hbspt.forms.create(context);
      }
    });
    /* eslint-enable */
    const hubspotForm = document.getElementById(id);
    if (!hubspotForm || !hubspotForm.hasChildNodes()) {
      return;
    }

    return () => {
      document.body.removeChild(formShell);
      hubspotForm.innerHTML = '';
    };
  }, [id, context]);
}
